import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button
} from '@mui/material';
import { Download } from '@mui/icons-material';
import Papa from 'papaparse';

const ModelResultsTabs = ({ results }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const modelTabs = [
    { label: 'GPT', data: Object.values(results.gpt || {}) },
    { label: 'Gemini', data: Object.values(results.gemini || {}) },
    ...(Array.isArray(results.arbitration) && results.arbitration.length > 0
      ? [{ label: 'Arbitration', data: results.arbitration }]
      : []),
  ];

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleExport = () => {
    const currentData = modelTabs[selectedTab]?.data || [];
    const isArbitration = modelTabs[selectedTab].label === 'Arbitration';

    const csv = Papa.unparse(
      currentData.map((row) =>
        isArbitration
          ? {
              'Clause Title': row.clause,
              Winner: row.winner,
              Priority: row.priority,
              Issue: row.issue,
              'Suggested Edit': row.suggested_edit,
            }
          : {
              'Clause Title': row.title,
              Status: row.status,
              Priority: row.priority,
              Issue: row.issue,
              'Suggested Edit': row.suggested_action?.proposed_language || '',
            }
      )
    );

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${modelTabs[selectedTab].label}-results.csv`;
    a.click();
  };

  return (
    <Box sx={{ width: '100%', mt: 4 }}>
      <Tabs value={selectedTab} onChange={handleChange} centered>
        {modelTabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {modelTabs.map((tab, index) =>
        selectedTab === index ? (
          <Paper key={index} elevation={2} sx={{ mt: 2, p: 2 }}>
            {tab.data.length > 0 ? (
              <>
                <Button
                  variant="outlined"
                  startIcon={<Download />}
                  onClick={handleExport}
                  sx={{ mb: 2, color: 'secondary.main', borderColor: 'secondary.main' }}
                >
                  Download CSV
                </Button>

                <Table>
                  <TableHead>
                    <TableRow>
                      {tab.label === 'Arbitration' ? (
                        <>
                          <TableCell>Clause Title</TableCell>
                          <TableCell>Winner</TableCell>
                          <TableCell>Priority</TableCell>
                          <TableCell>Issue</TableCell>
                          <TableCell>Suggested Edit</TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell>Clause Title</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Priority</TableCell>
                          <TableCell>Issue</TableCell>
                          <TableCell>Suggested Edit</TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tab.data.map((row, i) => (
                      <TableRow key={i}>
                        {tab.label === 'Arbitration' ? (
                          <>
                            <TableCell>{row.clause}</TableCell>
                            <TableCell>{row.winner}</TableCell>
                            <TableCell>{row.priority}</TableCell>
                            <TableCell>{row.issue}</TableCell>
                            <TableCell>{row.suggested_edit}</TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>{row.clause}</TableCell>
                            <TableCell>{row.status}</TableCell>
                            <TableCell>{row.priority}</TableCell>
                            <TableCell>{row.issue}</TableCell>
                            <TableCell>
                              {row.suggested_action?.instruction} <br />
                              {row.suggested_action?.proposed_language}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </>
            ) : (
              <Typography variant="body2">No data available for {tab.label}</Typography>
            )}
          </Paper>
        ) : null
      )}
    </Box>
  );
};

export default ModelResultsTabs;